import type { FlightRoute } from 'common/packageCache';
import moment from 'moment';

function renderLastSeenAtCell(text: string, record: FlightRoute): string {
  return record.updateTime ? moment(record.updateTime).format('YYYY-MM-DD') : '';
}

export default renderLastSeenAtCell;
